export function prepareStationsV1(data) {
  var map = new Map();

  var _loop = function _loop() {
    var _data$lines$find;

    var key = _Object$keys[_i];
    var id = Number(key);
    var station = data.stations[id];
    map.set(id, {
      id: id,
      name: station.name,
      color: (_data$lines$find = data.lines.find(function (line) {
        return line.ids.includes(id);
      })) === null || _data$lines$find === void 0 ? void 0 : _data$lines$find.color
    });
  };

  for (var _i = 0, _Object$keys = Object.keys(data.stations); _i < _Object$keys.length; _i++) {
    _loop();
  }

  return map;
}